module.exports = __webpack_public_path__ + "static/media/map-clothing.21e2dd63.png";